import { BatchClassModelType } from '@models/BatchClass';
import { HSMSSelectOption } from '@components/shared';
import { batchForStudentBatchAssignmentQuery } from '@app-types/graphql-types';

export const getBatchClassesForSelect = (
  batchClasses?: (BatchClassModelType | batchForStudentBatchAssignmentQuery['active_batch'][0]['batch_classes'][0])[],
): HSMSSelectOption[] => {
  if (batchClasses) {
    const batchClassesForSelect = batchClasses.map((batchClass) => {
      return {
        value: batchClass.id,
        label: batchClass.name,
      };
    });

    return batchClassesForSelect.sort((firstValue, secondValue) => firstValue.label.localeCompare(secondValue.label));
  }

  return [];
};
